module.exports = __webpack_public_path__ + "img/w3_share_dark.8e7c2ee7.png";